export default "__VITE_ASSET__BK_sGsD9__"